module.exports = __webpack_public_path__ + "img/46_31.2204c2fd.png";